import { Row } from 'react-table';
import memoize from 'lodash/memoize';
import { Filter } from '../DataGridFilterMenu/DataGridFilterTypes';
import { isAfter, isBefore, isEqual, startOfDay } from 'date-fns';

type FilterFunction = (cellValue: string | number | boolean | unknown, inputValue: string) => boolean;

const isFilter: FilterFunction = (cellDateValue, inputDateValue) => {
  const cellDate = startOfDay(new Date(cellDateValue as Date));
  const inputDate = startOfDay(new Date(inputDateValue));

  return isEqual(cellDate, inputDate);
};

const isBeforeFilter: FilterFunction = (cellDateValue, inputDateValue) => {
  const cellDate = startOfDay(new Date(cellDateValue as Date));
  const inputDate = startOfDay(new Date(inputDateValue));

  return isBefore(cellDate, inputDate);
};

const isAfterFilter: FilterFunction = (cellDateValue, inputDateValue) => {
  const cellDate = startOfDay(new Date(cellDateValue as Date));
  const inputDate = startOfDay(new Date(inputDateValue));

  return isAfter(cellDate, inputDate);
};

const isEmptyFilter: FilterFunction = (cellDateValue, _inputDateValue) => {
  return !cellDateValue;
};

const isNotEmptyFilter: FilterFunction = (cellDateValue, _inputDateValue) => {
  return !!cellDateValue;
};

const memoizeResolver = (...args: any[]) => args.join('_'); // eslint-disable-line
const filtersByOperator: Record<string, FilterFunction> = {
  is: memoize(isFilter, memoizeResolver),
  isBefore: memoize(isBeforeFilter, memoizeResolver),
  isAfter: memoize(isAfterFilter, memoizeResolver),
  isEmpty: memoize(isEmptyFilter, memoizeResolver),
  isNotEmpty: memoize(isNotEmptyFilter, memoizeResolver),
};

const runAllFiltersOnRow = (row: Row, filters: Filter[]) => {
  // Find a filter that causes the row to be removed
  return !filters.find((filter) => {
    const filterFunc = filtersByOperator[filter.operator as string];
    return !filterFunc(row.values[filter.columnId as string], filter.value as string);
  });
};

const dataGridDateFilterFunc = (rows: Row[], columnIds: string[], filterValue: Filter[]): Row[] => {
  const filters = filterValue.filter((filter: Filter) => {
    return !!filter?.operator && !!filter?.columnId && !!filter.value && !!filtersByOperator[filter.operator];
  });

  return rows.filter((row) => {
    return runAllFiltersOnRow(row, filters);
  });
};

export default dataGridDateFilterFunc;
